

export default {
    name: "the-welcome",
    props: {
        title: {
            required: true,
            default: ''
        },
        description: {
            required: true,
            default: ''
        },
        icon: {
            required: false,
            default: 'fxt-check'
        }
    },
    created(){
        setTimeout( () => this.$emit('close'), 3000);
    }
};
